import React from 'react';
import Countdown from '../../../../components/Countdown/Countdown';
import ImageSlider from '../../../../components/ImageSlider/ImageSlider';
import LeadForm from '../../../../components/LeadForm/LeadForm';
import { useStateContext } from '../../../../context/ContextProvider';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';
import Footer from '../../../../components/Footer/Footer';
import NoiseBackground from '../../../../components/Background/NoiseBackground';
import Height15 from '../../../../components/Gap/Height';
import HikalLeadForm from '../../../../components/LeadForm/HikalLeadForm';
import HikalLeadFormLuxury from '../../../../components/LeadForm/HikalLeadFormLuxury';

function BinghattiAlJaddafHikal({
    language
}) {
    const {
        langs,
        langCode,
        userInfo
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    // const isUAE = userInfo?.countryName === 'United Arab Emirates';
    // const isSaudia = userInfo?.countryName === 'Saudi Arabia';
    // const isSaudia = true;


    const images = [
        "/assets/images/projects/binghatti-aljaddaf/1.webp",
        "/assets/images/projects/binghatti-aljaddaf/2.webp",
        "/assets/images/projects/binghatti-aljaddaf/3.webp",
        "/assets/images/projects/binghatti-aljaddaf/4.webp"
    ];

    const poster = "/assets/images/projects/binghatti-aljaddaf/1.webp";
    const webm = "/assets/images/projects/binghatti-aljaddaf/hero.webm";
    const mp4 = "/assets/images/projects/binghatti-aljaddaf/hero.mp4";

    return (
        <>
            <div>
                <NoiseBackground />

                {/* LANGUAGE */}
                <LanguageNavigate
                    support={["en", "ar", "fa"]}
                    redirect={{
                        en: "/projects/binghatti/aljaddaf",
                        ar: "/projects/binghatti/aljaddaf/ar",
                        fa: "/projects/binghatti/aljaddaf/fa"
                    }}
                />

                {/* IMAGES */}
                <div className="fixed top-0 left-0 w-full flex justify-center -z-1 lg:hidden" style={{ zIndex: 0 }}>
                    <video
                        autoPlay={true}
                        loop={true}
                        muted={true}
                        playsInline={true}
                        preload="auto"
                        poster={poster}
                        width="350"
                        height="350"
                        className={`w-full md:max-w-[550px]`}
                    >
                        <source src={webm} type="video/webm" />
                        <source src={mp4} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:px-[7%]">
                    <div className="h-full w-full items-center justify-center hidden lg:flex">
                        <video
                            autoPlay={true}
                            loop={true}
                            muted={true}
                            playsInline={true}
                            preload="auto"
                            poster={poster}
                            width="350"
                            height="350"
                            className={`w-full md:max-w-[550px] rounded-sm`}
                        >
                            <source src={webm} type="video/webm" />
                            <source src={mp4} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    {/* HEADING */}
                    <div className="relative px-[7%] lg:px-0 text-center my-5 py-5 z-1 flex flex-col gap-10 items-center" style={{ zIndex: 1 }}>
                        <div className="h-[300px] md:h-[400px] lg:h-0"></div>
                        <div className="luxury-card flex flex-col gap-10 py-6">
                            <div className="px-2">
                                {language === "ar"
                                    ? (
                                         <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                            فرصتك قبل الطرح من بن غاطي
                                            <br />
                                            شقتك تبعد
                                            <span className="text-2xl bounce-text secondary-text">
                                                6
                                            </span>
                                            دقائق فقط من
                                            <br />
                                            برج خليفة ودبي مول
                                        </h1>
                                    ) : language == "fa" ? (
                                        <>
                                            <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                                {/* فرصتی طلایی قبل از پیش فروش پروژه */}
                                                فرصتی طلایی قبل از پیش فروش پروژه بن غاطی
                                                <br />
                                                آپارتمان رویایی تان تنها
                                                <span className="text-3xl lg:text-5xl px-2 vazirmatn">
                                                    ۶
                                                </span>
                                                دقیقه
                                                <br />
                                                تا شکوه برج خلیفه و جذابیت دبی مال فاصله داره
                                            </h1>
                                        </>
                                    ) : (
                                        <>
                                             <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl">
                                                A chance before the launch from Binghati!
                                                <br />
                                                Your apartment only
                                                <span className="text-2xl bounce-text secondary-text">
                                                    6
                                                </span>
                                                minutes away from
                                                <br />
                                                Burj Khalifa and The Dubai Mall
                                            </h1>
                                        </>
                                    )
                                }
                            </div>

                            {/* LIMITED TIME OFFER */}
                            <div className="w-full px-4">
                                <div className="padding-container flex items-center justify-center">
                                    <Countdown addClass={"-luxury"} />
                                </div>
                            </div>

                            {/* LEAD FORM */}
                            <div className="w-full px-4">
                                <HikalLeadFormLuxury
                                    developer="Binghatti"
                                    project="Al Jaddaf"
                                    leadType="Apartment"
                                    language={language === "ar" ? "Arabic" : language === "fa" ? "Farsi" : "English"}
                                    enquiries={["Studio", "1 Bedroom", "2 Bedrooms"]}
                                    askEmail={false}
                                    assignedToManager={language == "fa" ? 120 : null}
                                    assignedToSales={language == "fa" ? 518 : null}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default BinghattiAlJaddafHikal;
